import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { ImpactReportPage } from '@/features/reports/impact/impact-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Hayven's impact at `/$orgId/reports/impact`, open to every report viewer. */
export const Route = createFileRoute('/_auth/$orgId/reports/impact')({
  component: ImpactRoute,
})

function ImpactRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle("Hayven's impact")}</title>
      </Helmet>
      <ImpactReportPage />
    </>
  )
}
